import React from "react";

export const LeftTextPart = () => {
  return (
    <div>
      <div className="w-full flex flex-col gap-3 p-4 md:p-0 md:mb-0 mb-48">
        {/* <h1 className="text-[#ccd6f6] text-md md:text-xl text-left">
          Hello! My name is Brittany and I enjoy creating things that live on
          the internet. My interest in web development started back in 2012 when
          I decided to try editing custom Tumblr themes — turns out hacking
          together a custom reblog button taught me a lot about HTML & CSS!
        </h1> */}

        {/* <h1 className="text-[#ccd6f6] text-sm md:text-md text-left">
          As a full-stack developer and web 3.0 developer, I am a versatile and
          technically adept professional with a passion for creating innovative
          and cutting-edge web applications. I have a deep understanding of web
          development technologies, frameworks, and tools, including React,
          Angular, Node.js, Ethereum, and Solidity. I have experience building
          decentralized applications (dApps) using blockchain technology, smart
          contracts, and web3.js. My strong technical background, combined with
          my agile and collaborative approach, enables me to create scalable,
          high-performance, and reliable web solutions. I am a detail-oriented
          problem-solver who is dedicated to delivering exceptional results and
          exceeding client and user expectations. I am a quick learner, always
          keeping up with the latest advancements and best practices in the
          field, and I am constantly seeking new challenges and opportunities to
          expand my knowledge and skills. Overall, I am a results-driven and
          customer-focused full-stack and web 3.0 developer, committed to
          delivering the highest quality web solutions that meet and exceed
          client and user needs.
        </h1> */}

        <h1 className="text-[#ccd6f6] text-sm md:text-md text-left">
          As a Full Stack Developer, I bring a diverse skill set and a passion
          for creating robust and user-friendly web applications. With
          experience in both front-end and back-end development, I strive to
          deliver seamless and engaging user experiences. My expertise includes
          building responsive and intuitive user interfaces using modern
          JavaScript frameworks like React.js and Angular. On the server-side, I
          am proficient in working with Node.js and frameworks such as
          Express.js . I have hands-on experience in designing and implementing
          secure databases, using technologies like MySQL and MongoDB. I am
          adept at integrating various APIs and services, ensuring seamless
          third-party integrations. With a strong foundation in software
          engineering principles, I focus on writing clean and scalable code,
          following industry best practices. Constantly staying updated with the
          latest technologies and trends, I am enthusiastic about solving
          complex problems and delivering innovative solutions. With excellent
          communication and teamwork skills, I thrive in collaborative
          environments and am committed to delivering high-quality results that
          exceed client expectations.
        </h1>

        <h1 className="text-[#ccd6f6] text-sm md:text-md text-left">
          "Web 3.0 is the future of the internet, and full-stack developers are
          the pioneers who will lead us there. With their versatile skills and
          innovative thinking, they have the power to create the next generation
          of web applications that will change the world for the better."
        </h1>

        <div className="flex gap-10 md:gap-24 md:pl-4">
          <div className="flex flex-col pl-4 md:p-0">
            <ul className="style_list text-[#ccd6f6]  marker:text-green-300">
              <li>JavaScript (ES6+)</li>
              <li>React</li>
              <li>React Hook</li>
              <li>React Native</li>
              <li>Redux Toolkit</li>
              <li>HTML5</li>
              <li>CSS3</li>
            </ul>
          </div>
          <div className="flex flex-col">
            <ul className="style_list text-[#ccd6f6] marker:text-green-300">
              <li>Tailwindcss</li>
              <li>Bootstrap</li>
              <li>Angular</li>
              <li>Typscript </li>
              <li>Node.js</li>
              <li>MongoDB</li>
            </ul>
          </div>
          <div className="flex flex-col">
            <ul className="style_list text-[#ccd6f6] marker:text-green-300">
              <li>Expressjs</li>
              <li>MYSQL</li>
              <li>Next.js</li>
              <li>Smart Contracts</li>
              <li>Solidity Programming</li>
              <li>Ethereum</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
